export default __webpack_public_path__ + "static/pragicts-secops-services-website-security-d64b34dc80064a3698e2bb54b3cd7813.jpg";